import { topicTags } from '@/mocks/homeData';

const heatStyles: Record<string, string> = {
  '超热': 'bg-accent-100 text-accent-700',
  '热门': 'bg-primary-100 text-primary-700',
  '上升': 'bg-secondary-100 text-secondary-700',
};

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            话题标签
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            热门题材标签，点击探索你感兴趣的内容方向，发现更多同好喜爱的漫画
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {topicTags.map((tag) => (
            <a
              key={tag.name}
              href="#topics"
              className="group flex items-center justify-between p-4 md:p-5 rounded-2xl bg-background-50 border border-background-200/60 cursor-pointer hover:border-primary-200 transition-colors duration-200"
            >
              <div className="flex items-center gap-3">
                <span className="text-sm md:text-base font-heading text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {tag.name}
                </span>
                <span
                  className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                    heatStyles[tag.heat] || 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {tag.heat}
                </span>
              </div>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <span className="whitespace-nowrap">{tag.count} 作品</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}